// eslint-disable-next-line no-restricted-imports -- this is the one file allowed to wrap the real @emotion/styled
import emotionStyled from '@emotion/styled';

// Drop-in replacement for `@emotion/styled` used throughout embed/cart/. Every
// component created through this module gets `all: revert` as its first
// declaration automatically, so the host page's ambient/global CSS can't leak
// into any element the cart renders — no per-component boilerplate needed,
// and no reliance on cascade order between this and the component's own
// (later, always-winning) declarations in the same rule.
const RESET = { all: 'revert' };

const withReset = (createStyledComponent) => (...styles) => createStyledComponent(RESET, ...styles);

const styled = new Proxy(emotionStyled, {
    apply(target, thisArg, argumentsList) {
        return withReset(Reflect.apply(target, thisArg, argumentsList));
    },
    get(target, prop, receiver) {
        const value = Reflect.get(target, prop, receiver);
        return typeof value === 'function' ? withReset(value) : value;
    },
});

export default styled;
